'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kyleshockey/js-yaml/index.js
// module id = 232
// module chunks = 0